import { render, staticRenderFns } from "./Designer.vue?vue&type=template&id=7d4e53e4&scoped=true"
import script from "./Designer.vue?vue&type=script&setup=true&lang=js"
export * from "./Designer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Designer.vue?vue&type=style&index=0&id=7d4e53e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4e53e4",
  null
  
)

export default component.exports